import type { IUseGetSocialApplyByStatusQuery } from "@api";
import { useReducer } from "react";
import type { FiltersActions, TCandidateFilters } from "./types";

const initialState: TCandidateFilters = {
  search: "",
  place: [],
  status: [],
};

export const filtersReducer = (state: TCandidateFilters, action: FiltersActions): TCandidateFilters => {
  let newState: TCandidateFilters;

  switch (action.type) {
    case "search":
    case "place":
    case "status":
      newState = {
        ...state,
        [action.type]: action.payload,
      };
      break;
    case "reset":
      newState = initialState;
      break;
    default:
      return state;
  }

  if (JSON.stringify(state) === JSON.stringify(newState)) {
    return state;
  }

  return newState;
};

export const formatFilters = (filters: TCandidateFilters): IUseGetSocialApplyByStatusQuery["filters"] => {
  return {
    search: filters.search || undefined,
    candidatePlace: filters.place.map((item) => item._id) || undefined,
    candidateStatus: filters.status.map((item) => item.value) || undefined,
  };
};

export const useCandidateFilters = () => {
  const [filters, dispatch] = useReducer(filtersReducer, initialState);
  return { filters, dispatch };
};
